import React from "react";
import { Box, Typography, Paper, Stack, Button } from "@mui/material";
import { logOut } from "../firebase";

interface SettingsProps {
  userName: string | null;
  onNavigate: (page: string) => void;
  onSignOut: () => void;
}

export default function Settings({
  userName,
  onNavigate,
  onSignOut,
}: SettingsProps): JSX.Element {
  const handleSignOut = () => {
    onSignOut();
  };

  return (
    <Box sx={{ maxWidth: 720, ml: 0, mt: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
        Settings
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
        Quick access to profile and account actions.
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={2}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Account
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button variant="outlined" onClick={() => onNavigate("profile")}>
              View profile
            </Button>
            <Button
              variant="outlined"
              onClick={() => onNavigate("manage-plan")}
            >
              Manage plan
            </Button>
            <Button variant="contained" color="primary" onClick={handleSignOut}>
              Sign out {userName ? `(${userName})` : ""}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
